import React, { useEffect, useState } from 'react';
import query from '../../../../../../server/constants.api';
import useFetch from '../../../../../../server/useFetch';
import ItemRelationsModal from './ItemRelationsModal/ItemRelationsModal';

const ItemRelations = ({ isItemRelationsModalOpen, handleItemRelationsClose, itemSelected }) => {

    const [itemRelationsData, setItemRelationsData] = useState([]);

    const {
        data: providersData,
        refetch: refetchProvidersData,
        isFetching: isFetchingProvidersData,
        remove: removeProvidersData,
    } = useFetch(
        query.path.providersData,
        "configurationsItemProviders",
        {
            id: itemSelected?.id,
            level: 1,
        },
        false,
        null,
        `${query.middlewareURL}/digital-twin`
    );


    const {
        data: dependentsData,
        refetch: refetchDependentsData,
        isFetching: isFetchingDependentsData,
        remove: removeDependentsData
    } = useFetch(
        query.path.dependentsData,
        "configurationsItemDependents",
        {
            id: itemSelected?.id,
            level: 1,
        },
        false,
        null,
        `${query.middlewareURL}/digital-twin`
    );

    /**
     * UseEffect to refetch data when the modal is open
     */
    useEffect(() => {
        if (itemSelected && isItemRelationsModalOpen) {
            refetchDependentsData();
            refetchProvidersData();
        }
    }, [itemSelected, isItemRelationsModalOpen]);


    /**
     * UseEffect to remove data when the modal is closed
     */
    useEffect(() => {
        if (!isItemRelationsModalOpen) {
            removeDependentsData();
            removeProvidersData();
            setItemRelationsData([]);
        }
    }, [isItemRelationsModalOpen]);

    useEffect(() => {
        if (providersData && dependentsData) {
            setItemRelationsData([])
        }
    }, [providersData, dependentsData]);

    /**
     * Function to map the relationships data for the table
     * @param {*} data The data to map the relationships from dependents or providers
     * @param {*} type The type of the data (dependents or providers)
     * @returns The mapped data in a array of objects
     */
    const mapRelationshipsData = (data, type) => {
        const { relationships, [type]: items } = data;
        return relationships.map(({ id, outV, inV, label, weight, is_peer }) => ({
            id,
            relation: label,
            parent: items.find((item) => item?.id === outV)?.name,
            child: items.find((item) => item?.id === inV)?.name,
            weight,
            isPeer: is_peer,
        }));
    };

    /**
     * UseEffect to set the item relations data when the providers and dependents data are fetched
     */
    useEffect(() => {
        if (providersData && dependentsData && itemSelected) {
            const modifiedProvidersData = { ...providersData, providers: [...providersData.providers, itemSelected] };
            const modifiedDependentsData = { ...dependentsData, dependents: [...dependentsData.dependents, itemSelected] };

            const providersMappedData = mapRelationshipsData(modifiedProvidersData, "providers");
            const dependentsMappedData = mapRelationshipsData(modifiedDependentsData, "dependents");
            setItemRelationsData([...providersMappedData, ...dependentsMappedData]);
        }
    }, [providersData, dependentsData]);

    return (
        <ItemRelationsModal
            handleItemRelationsClose={handleItemRelationsClose}
            isItemRelationsModalOpen={isItemRelationsModalOpen}
            itemRelationsData={itemRelationsData}
            isLoading={isFetchingProvidersData || isFetchingDependentsData}
            itemSelectedName={itemSelected?.name}
            refetchData={() => {
                refetchProvidersData();
                refetchDependentsData();
            }}
        />
    );
};

export default ItemRelations;
